import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { OpEnum } from '../../../shared/enums/op.enum';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService, } from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { IdentificationService } from '../../../shared/services/identification/identification.service';
import { BackDocumentScanImage } from './back-document-scan-image';
/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
var BackDocumentScanComponent = /** @class */ (function () {
    /**
     * Summary Constructor of the component.
     *
     * @param {HeaderService}              headerService              Injectable headerService service.
     * @param {AbreCuentasService}         abreCuentasService         Injectable abreCuentasService service.
     * @param {IdentificationService}      identificationService      Injectable identificationService service.
     * @param {ChannelCommunicatorService} channelCommunicatorService Injectable channelCommunicatorService service.
     * @param {ParametersService}          ParametersService          Injectable parametersServices service
     * @function headerService.show(true,true)
     */
    function BackDocumentScanComponent(copyService, headerService, abreCuentasService, identificationService, channelCommunicatorService, parametersService, navigationService, taggingServices, loaderService, bitacoraService) {
        this.copyService = copyService;
        this.headerService = headerService;
        this.abreCuentasService = abreCuentasService;
        this.identificationService = identificationService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.parametersService = parametersService;
        this.navigationService = navigationService;
        this.taggingServices = taggingServices;
        this.loaderService = loaderService;
        this.bitacoraService = bitacoraService;
        /**
         * Variable de validación para mostrar modal
         *
         * *Validation variable to showModal*
         *
         * @access public
         * @type {boolean}
         */
        this.showModal = false;
        /**
         * Copies de los labels del modal
         *
         * *Labels modal copies*
         *
         * @access public
         * @type {Object}
         */
        this.buttonLabelsModal = {};
        /**
         * Variable de validación de botón habilitado
         *
         * *Validation variable to disable button*
         *
         * @access public
         * @type {boolean}
         */
        this.isBtnDisabled = true;
        this.headerService.show(true, true, true);
        this.buttonLabelsModal = {
            primary: copyService.copies.back_document_modal_button_primary,
        };
    }
    /**
     * Configuracion de imagen, términos y condiciones y máximo intentos de escaner
     * en el momento que el componente es montado
     *
     * *Image, terms and conditions and max scan attempts config once the component is mount*
     */
    BackDocumentScanComponent.prototype.ngOnInit = function () {
        this.image = {
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: BackDocumentScanImage,
        };
        this.terms = {
            text: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].description,
            title: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].code,
            terms_id: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].id,
        };
        this.checkboxTerms = {
            id: this.terms.terms_id,
            label: 'Autorizo el tratamiento de mis datos según la siguiente política: ',
            checked: false,
            value: this.terms.terms_id,
        };
        this.maxScanAttempts = this.abreCuentasService.getBytteConfig().failedAttempts.backDocumentScan;
    };
    // /**
    //  * Acción del modal
    //  *
    //  * *Modal action*
    //  *
    //  * @param event
    //  * @type {function}
    //  */
    // modalAction(event) {
    //   if (event.type === 'primary') {
    //     this.downloadPdf();
    //   }
    // }
    BackDocumentScanComponent.prototype.next = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bitacoraEvent;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                // this.loaderService.show();
                this.sendTagging('next', 'bottom', '2');
                bitacoraEvent = 'term_condition_accept';
                this.identificationService.backDocumentScan().then(function (response) {
                    _this.identificationService.callbackBackDocumentScan(response);
                    _this.bitacoraService.saveDataInBitacora(bitacoraEvent);
                }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
                return [2 /*return*/];
            });
        });
    };
    BackDocumentScanComponent.prototype.sendTagging = function (value, position, event, extras) {
        var page = '30';
        this.taggingServices.sendTaggValues(value, page, position, event, extras);
    };
    /**
     * Servicio para enviar datos a Google analytics
     *
     * *Send data to Google Analytics*
     */
    BackDocumentScanComponent.prototype.toggleModal = function () {
        // this.downloadPdf();
        var tagPageName = this.navigationService.getCurrentStep().tag_name;
        try {
            var changes = [
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionDetailsProductcategory"].value,
                },
                {
                    path: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].path,
                    value: EVENT[tagPageName + "E1setData"][tagPageName + "E1transactionName"].value,
                },
            ];
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module.body,
                    type: EVENT.customCategory.type.link,
                    position: EVENT.customCategory.position.top,
                },
                action: EVENT.customAction.click,
                label: EVENT[tagPageName + "E1customLabel"],
            };
            this.taggingServices.pageTagEvent(event_1, changes);
        }
        catch (error) {
            console.log("Error en: " + error);
        }
        this.showModal = !this.showModal;
        if (this.showModal) {
            this.navigationService.pageLoadTag(false, ['pv5', 'pv109', 'pv69', '']);
        }
    };
    /**
     * Evento para cambiar el estado de checkbox y establece la propiedad
     *
     * *Summary Event to change checkbox and set Prop*
     *
     * @param {any} event
     */
    BackDocumentScanComponent.prototype.checkboxChange = function (event) {
        this.checkboxTerms.checked = event.checked;
        this.abreCuentasService.setFiProperty('checkboxTerms', this.checkboxTerms);
        this.enableNextButton();
    };
    /**
     * Método para descargar el PDF
     *
     * *Method to download pdf*
     */
    BackDocumentScanComponent.prototype.downloadPdf = function () {
        this.channelCommunicatorService.getImpl().openPdf(this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].pdfUrl);
    };
    /**
     * Habilitar botón
     *
     * *Summary Enable the Button*
     */
    BackDocumentScanComponent.prototype.enableNextButton = function () {
        this.isBtnDisabled = !(this.abreCuentasService.getFiProperty('checkboxTerms').checked);
    };
    return BackDocumentScanComponent;
}());
export { BackDocumentScanComponent };
